<template>
  <div id="paymentSummary">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>数据中心</el-breadcrumb-item>
          <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
          <el-breadcrumb-item>场库对账明细报表</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-form :inline="true"
             label-width="90px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="客户::">
            <el-select v-model="pageSearch.fCustID"
                       clearable
                       filterable
                       placeholder="请选择客户"
                       @change="loadPark"
                       style="width:200px;">
              <el-option v-for="item in cust_list"
                         :key="item.fCustID"
                         :label="item.unionName"
                         :value="item.fCustID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="场库::">
            <el-select v-model="pageSearch.fParkID"
                       filterable
                       placeholder="请选择场库"
                       style="width:200px;"
                       clearable>
              <el-option v-for="item in park_list"
                         :key="item.fParkID"
                         :label="item.fParkName"
                         :value="item.fParkID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="操作员编号::">
            <el-input placeholder="请输入操作员编号"
                      v-model="pageSearch.searchKeyWord"
                      :disabled="userNoDisabled"
                      class="search"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-checkbox v-model="pageSearch.isRed">只显示有差额记录</el-checkbox>
          </el-form-item>
          <el-form-item label="">
            <el-checkbox v-model="pageSearch.isNormal">不显示异常记录</el-checkbox>
          </el-form-item>
          <el-form-item label="">
            <el-checkbox v-model="pageSearch.isZero">只显示有金额记录</el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <!-- <el-form-item label="时间选择::">
            <el-select v-model="pageSearch.fTimeType"
                       filterable
                       placeholder="请选择时间"
                       @change="changeTime"
                       style="width:200px;">
              <el-option v-for="item in time_Type"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="开始时间::">
            <el-date-picker v-model="startTime"
                            style="width:200px"
                            :picker-options="startPickerOptions"
                            @change="changeStartTime"
                            type="datetime"
                            :clearable="false"
                            placeholder="选择开始时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间::">

            <el-date-picker v-model="endTime"
                            style="width:200px"
                            @change="changeEndTime"
                            :picker-options="endPickerOptions"
                            :clearable="false"
                            type="datetime"
                            placeholder="选择结束时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="车牌::">
            <el-input placeholder="请输入车牌"
                      v-model="pageSearch.fPlateCode"
                      class="search">
              <!-- <i slot="prefix"
                 class="el-input__icon el-icon-search"></i> -->
            </el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary"
                       size="small"
                       icon="el-icon-search"
                       @click="page_list">查询</el-button>
            <el-button type="success"
                       size="small"
                       icon="el-icon-share"
                       :loading="export_loading"
                       v-if="is_export"
                       @click="exportData">{{export_msg}}</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="pageData"
                  :height="tableHeight"
                  highlight-current-row
                  v-loading="loading"
                  ref="dt"
                  :summary-method="getSummaries"
                  :row-class-name="tableRowClassName"
                  show-summary
                  border
                  stripe
                  style="width: 100%">
          <el-table-column width="50"
                           type="index"
                           :index="indexMethod"
                           label="序号">
          </el-table-column>
          <el-table-column prop="fCustNo"
                           width="80"
                           label="客户编号">
          </el-table-column>
          <el-table-column prop="fInParkName"
                           label="场库名称">
          </el-table-column>
          <el-table-column prop="fOpUserName"
                           label="操作人员">
          </el-table-column>
          <el-table-column prop="fPlateCode"
                           label="车牌号码">
          </el-table-column>
          <el-table-column prop="fInTime"
                           width="155px"
                           label="进场时间">
          </el-table-column>
          <el-table-column prop="fOutTime"
                           width="155px"
                           label="出场时间">
          </el-table-column>
          <el-table-column prop="fCalcAmt"
                           align="right"
                           label="计费金额">
          </el-table-column>
          <el-table-column prop="fFreePayAmt"
                           align="right"
                           label="免费金额">
          </el-table-column>
          <el-table-column prop="fDedAmt"
                           align="right"
                           label="抵扣金额">
          </el-table-column>
          <el-table-column prop="fCashPayAmt"
                           align="right"
                           label="现金">
          </el-table-column>
          <el-table-column prop="fOnlinePayAmt"
                           align="right"
                           label="电子支付">
          </el-table-column>
          <el-table-column prop="fPayAmt"
                           align="right"
                           label="实收金额">
          </el-table-column>
          <el-table-column prop="fExpAmt"
                           align="right"
                           label="差额异常">
          </el-table-column>
          <el-table-column label="操作"
                           align="center"
                           fixed="right"
                           width="90">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="success"
                         @click="handleInfo(scope.$index, scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination @current-change="handleCurrentChange"
                         @size-change="handleSizeChange"
                         :current-page="pageSearch.pageIndex"
                         :page-size="pageSearch.pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         background
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="pageCount"
                         v-if="pageCount>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <carInfoView ref="child"
                 reportActiveName="pageData"
                 :type="2"
                 :isOld="true"></carInfoView>
  </div>
</template>

<script>
import carInfoView from '../../components/carInfoView'
import { report as api } from '../../api/report'
import * as park from '../../api/park'
import * as user from '../../api/user'
import $ from 'jquery'
const delay = (function () {
  let timer = 0
  return function (callback, ms) {
    clearTimeout(timer)
    timer = setTimeout(callback, ms)
  }
})()
export default {
  components: { carInfoView },
  name: 'paymentSummary',
  data () {
    return {
      startPickerOptions: {
        disabledDate: this.disabledDate
      },
      endPickerOptions: {
        disabledDate: this.disabledDate
      },
      park_list: [],
      payType_list: [],
      title: '业务数据中心',
      is_export: false,
      tableHeight: 0,
      loading: false,
      export_loading: false,
      export_msg: '导出',
      pageData: [],
      cust_list: [],
      time_Type: [{ label: '最近三个月', value: 0 }, { label: '历史数据(按年划分)', value: 1 }],
      startTime: '',
      endTime: '',
      pageCount: 0,
      userNoDisabled: true,
      total: {
        fCalcAmt: '0',
        fFreePayAmt: '0',
        fDedAmt: '0',
        fCashPayAmt: '0',
        fOnlinePayAmt: '0',
        fPayAmt: '0',
        fExpAmt: '0'
      },
      pageSearch: {
        fTimeType: 1,
        pageIndex: 1,
        pageSize: 20,
        isRed: false,
        isZero: false,
        isNormal: false,
        fParkID: '',
        fStartTime: '',
        fEndTime: '',
        fPlateCode: '',
        searchKeyWord: '',
        isExport: 0
      },
      endMonthOption: {
      }
    }
  },
  methods: {
    // 搜索词搜索
    wordSearch () {
      delay(() => {
        this.page_list()
      }, 1000)
    },
    changeStartTime (time) {
      if (time.getFullYear() !== this.endTime.getFullYear()) {
        this.endTime = new Date(time.getFullYear(), this.endTime.getMonth(), this.endTime.getDate(), 23, 59, 59)
      }
    },
    changeEndTime (time) {
      if (time.getFullYear() !== this.startTime.getFullYear()) {
        this.startTime = new Date(time.getFullYear(), this.startTime.getMonth(), this.startTime.getDate(), 0, 0, 0)
      }
    },
    changeTime (type) {
      var today = new Date()
      if (type === 0) {
        this.startTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0)
        this.endTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59)
      } else {
        var month = today.getMonth()
        var year = today.getFullYear()
        var newMonth = (month - 2) <= 0 ? (month - 2 + 12) : (month - 2)
        var newYear = (month - 2) <= 0 ? (year - 1) : year
        this.startTime = new Date(newYear, newMonth - 1, 1, 0, 0, 0)
        var date = 0
        if (newMonth === 2) {
          if ((newYear % 4 === 0 && newYear % 100 !== 0) || newYear % 400 === 0) {
            date = 29
          } else {
            date = 28
          }
        } else {
          var array31 = [1, 3, 5, 7, 8, 10, 12]
          if (array31.indexOf(newMonth) > -1) {
            date = 31
          } else {
            date = 30
          }
        }
        this.endTime = new Date(newYear, newMonth - 1, date, 23, 59, 59)
      }
    },
    disabledDate (time) {
      var curTime = new Date()
      var month = curTime.getMonth()
      var year = curTime.getFullYear()
      var newMonth = (month - 1) <= 0 ? (month - 1 + 12) : (month - 1)
      var newYear = (month - 1) <= 0 ? (year - 1) : year
      var newTime = new Date(newYear + '/' + newMonth + '/1 00:00:00')
      if (this.pageSearch.fTimeType === 0) {
        return time.getTime() < newTime
      } else {
        // return time.getTime() >= newTime || time.getFullYear() < (year - 2)
        return time.getFullYear() < (year - 2)
      }
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.isRed) {
        return 'warning-row'
      }
      return ''
    },
    page_list (index) {
      if ((this.pageSearch.fCustID || '').trim().length <= 0) {
        this.$message.error('提示：请先选择客户')
        return false
      }
      if (index && index >= 1) {
        this.pageSearch.pageIndex = index
      } else {
        this.pageSearch.pageIndex = 1
      }
      this.loading = true
      this.pageSearch.fStartTime = this.$dateFormat(this.startTime, 'yyyy-MM-dd hh:mm:ss')
      this.pageSearch.fEndTime = this.$dateFormat(this.endTime, 'yyyy-MM-dd hh:mm:ss')
      this.pageSearch.isExport = 0
      api.paymentSummaryList(this.pageSearch).then(res => {
        this.loading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.pageData = data.Data.data || []
            this.pageCount = data.Data.count
            this.total = data.Data.total
            setTimeout(() => { this.$refs['dt'].doLayout() }, 100)
          } else {
            this.$message.error('提示：加载场库对账明细报表数据失败')
          }
        }
      })
    },
    getSummaries (param) {
      var sums = []
      for (let index = 0; index < 14; index++) {
        if (index === 1) {
          sums[index] = '合计'
        } else if (index === 7) {
          sums[index] = this.total.fCalcAmt
        } else if (index === 8) {
          sums[index] = this.total.fFreePayAmt
        } else if (index === 9) {
          sums[index] = this.total.fDedAmt
        } else if (index === 10) {
          sums[index] = this.total.fCashPayAmt
        } else if (index === 11) {
          sums[index] = this.total.fOnlinePayAmt
        } else if (index === 12) {
          sums[index] = this.total.fPayAmt
        } else if (index === 13) {
          sums[index] = this.total.fExpAmt
        } else {
          sums[index] = ''
        }
      }
      return sums
    },
    loadPark (fCustID) {
      // 场库
      this.pageSearch.fParkID = ''
      this.park_list = []
      if (fCustID) {
        this.userNoDisabled = false
        // 加载场库
        park.getParkList({ fCustID: fCustID }).then(res => {
          if (res && res.data) {
            var data = res.data
            if (data.IsOk) {
              this.park_list = data.Data
            } else {
              this.$message.error('提示：加载场库列表失败')
            }
          }
        })
      } else {
        this.pageSearch.searchKeyWord = ''
        this.userNoDisabled = true
      }
    },
    indexMethod (index) {
      return this.pageSearch.pageSize * (this.pageSearch.pageIndex - 1) + index + 1
    },
    handleSizeChange (val) {
      this.pageSearch.pageSize = val
      this.page_list(this.pageSearch.pageIndex)
    },
    handleCurrentChange (val) {
      this.page_list(val)
    },
    getCurrentMonthLast (dt) {
      var date = dt
      var currentMonth = date.getMonth()
      var nextMonth = ++currentMonth
      var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1)
      var oneDay = 1000 * 60 * 60 * 24
      var lastTime = new Date(nextMonthFirstDay - oneDay)
      var month = parseInt(lastTime.getMonth() + 1)
      var day = lastTime.getDate()
      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      return new Date(date.getFullYear() + '-' + month + '-' + day)
    },
    selectStartMonth () {
      var endMonth = this.endTime.getMonth()
      var startMonth = this.startTime.getMonth()
      if (endMonth !== startMonth) {
        this.endTime = this.getCurrentMonthLast(this.startTime)
      }
      this.endMonthOption = {
        disabledDate: (time) => {
          if (this.startTime !== '') {
            var endMonth = this.startTime.getMonth()
            var minMonth = time.getMonth()
            return time.getTime() < this.startTime.getTime() || minMonth !== endMonth
          }
        }
      }
    },
    selectEndMonth () {
    },
    exportData () {
      if ((this.pageSearch.fCustID || '').trim().length <= 0) {
        this.$message.error('提示：请先选择客户')
        return false
      }
      this.pageSearch.fStartTime = this.$dateFormat(this.startTime, 'yyyy-MM-dd hh:mm:ss')
      this.pageSearch.fEndTime = this.$dateFormat(this.endTime, 'yyyy-MM-dd hh:mm:ss')
      this.pageSearch.isExport = 1
      this.export_loading = true
      this.export_msg = '导出中……'
      var fileName = '所有客户'
      if ((this.pageSearch.fCustID || '').trim().length > 0) {
        var custArr = (this.cust_list || []).filter((item) => {
          return item.fCustID === this.pageSearch.fCustID
        })
        fileName = custArr.length > 0 ? custArr[0].unionName : ''
      }
      api.paymentSummaryList(this.pageSearch).then(res => {
        this.export_loading = false
        this.export_msg = '导出'
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.fileDownload(data.Data, fileName + '_场库对账明细报表（历史）.xls')
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    init () {
      var today = new Date()
      if (this.pageSearch.fTimeType === 1) {
        var year = today.getFullYear() - 1
        console.log(year)
        this.startTime = new Date(year, 11, 1, 0, 0, 0)
        this.endTime = new Date(year, 11, 31, 23, 59, 59)
      } else {
        this.startTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0)
        this.endTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59)
      }

      park.getCustByGroup({ fCustTypeID: 0 }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.cust_list = data.Data
            if (this.cust_list && this.cust_list.length === 1) {
              this.pageSearch.fCustID = this.cust_list[0].fCustID
              this.loadPark(this.pageSearch.fCustID)
            }
          } else {
            this.$message.error('提示：加载客户列表失败')
          }
        }
      })
      user.getCurrentUserPers({ perTypeId: 68300 }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.is_export = data.Data.data.is_export
            }
          } else {
            this.$message.error('提示：加载当前用户权限信息失败')
          }
        }
      })
    },
    handleInfo (index, row) {
      this.$refs.child.handleInfo(row)
    },
    setImgHeight () {
      var formHeight = $('.form_right').height()
      var fplateHeight = $('.fplate_info .el-image').height()
      var carImgHeight = $('.car_img .img').height()
      if (formHeight && fplateHeight > 0) {
        var height = (formHeight - fplateHeight - carImgHeight) / 2
        $('.fplate_info').css({ 'margin-top': height + 'px', 'margin-bottom': height + 'px' })
      }
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 250
      obj.tableHeight = clientHeight
    }
  },
  created () {

  },
  mounted () {
    window.onresize = () => {
      this.setTableHeight(this)
    }
    this.init()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>
<style >
/* dialog弹出框样式 */
#paymentSummary .el-dialog {
  min-width: 840px;
}
#paymentSummary .warning-row {
  color: red;
}
#paymentSummary .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
#paymentSummary .el-dialog__title {
  color: white;
}
#paymentSummary .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
#paymentSummary .el-dialog__body {
  padding: 3px 10px;
  font-size: 13px;
  /* font-family: "宋体"; */
}
#paymentSummary .fRemark > .el-textarea__inner {
  height: 100px;
}
#paymentSummary .fRemark_row .el-form-item__content {
  height: 100px;
}
#paymentSummary .fRemark_big > .el-textarea__inner {
  height: 135px;
}
#paymentSummary .fRemark_row_big .el-form-item__content {
  height: 135px;
}
#paymentSummary .el-input.is-disabled .el-input__inner,
#paymentSummary .el-textarea.is-disabled .el-textarea__inner {
  color: #606266;
}
#paymentSummary .el-table__footer-wrapper .cell {
  font-weight: bold;
  color: #064c67;
}
</style>
<style scoped>
.el-form-item {
  margin-bottom: 5px;
}
.pagination {
  text-align: right;
  padding-top: 5px;
}
.search {
  width: 200px;
}
.danger {
  color: #f56c6c;
}
.success {
  color: #67c23a;
}
</style>



// WEBPACK FOOTER //
// src/view/report/paymentSummaryOld.vue